window.checkElementModule = (function () {
  function rafAsync() {
    return new Promise((resolve) => {
      requestAnimationFrame(resolve); // faster than set time out
    });
  }
  function checkElement(selector) {
    if (document.querySelector(selector) === null) {
      return rafAsync().then(function () {
        return checkElement(selector);
      });
    } else {
      return Promise.resolve(selector);
    }
  }
  return { checkElement: checkElement };
})();

// Fancy JS Swatches
checkElementModule
  .checkElement('.product-section #color-swatches-search-wrapper')
  .then(function (element) {
    product_color_swatch();
  });
document.addEventListener('quick-view:open', function (event) {
  product_drawer_color_swatch();
});

function product_color_swatch() {
  var colorSwatchWrapper = $('#color-swatches-search-wrapper'),
    colorSwatchList = $('#color-swatches-search'),
    fullTitle = colorSwatchWrapper.data('product-title').toUpperCase(),
    termHandle = fullTitle.toLowerCase().replace(/ /g, '-'),
    term = $.trim(fullTitle)
      .toLowerCase()
      .split(' ')
      .join('+')
      .replace(/\'/, ''),
    searchURL =
      '/search.json?q=' +
      term +
      '&type=product&view=colors&options[unavailable_products]=show&title=' +
      termHandle +
      '.json';

  $.getJSON(searchURL, function (data) {
    if (data.results_count == 0) {
      console.log('no swatches');
      $('.loader-3-dots').remove();
      $('.variations--color-swatch').hide();
    } else {
      $.each(data.results, function (index, item) {
        var item_title = item.title.toUpperCase();
        if (item_title == fullTitle) {
          var activeClass =
            item.color == colorSwatchWrapper.data('product-color')
              ? 'class="active"'
              : '';
          var itemUrl = (item.url || '').replace(/&variant=[0-9]*/, '');
          var productHandleMatch = (item.url || '')
            .split('?')[0]
            .match(/\/products\/(.*)/i);
          if (Array.isArray(productHandleMatch))
            var productHandle = productHandleMatch[1];

          var swatch;
          if (item.hex) {
            swatch =
              '<a href="' +
              itemUrl.split('?')[0] +
              '" ' +
              activeClass +
              ' data-tooltip="' +
              item.color +
              '"><div class="color-square ' +
              item.available +
              '"><div class="color-square-inner" style="background-color:' +
              item.hex +
              '"></div></div></a>';
          } else if (item.image) {
            swatch =
              '<a href="' +
              itemUrl.split('?')[0] +
              '" ' +
              activeClass +
              ' data-tooltip="' +
              item.color +
              '"><div class="color-square ' +
              item.available +
              '"><div class="color-square-inner" style="background-image: url(' +
              item.image +
              ')"></div></div></a>';
          } else {
            swatch =
              '<a href="' +
              itemUrl.split('?')[0] +
              '" ' +
              activeClass +
              ' data-tooltip="' +
              item.color +
              '"><div class="color-square ' +
              item.available +
              '"><div class="color-square-inner"></div></div></a>';
          }
          colorSwatchList.append(swatch);
        }
      });

      if (colorSwatchList.children().length > 0) {
        $('.loader-3-dots').remove();
      }
      if (colorSwatchList.children().length == 1) {
        // colorSwatchList.hide();
      }
    }
  });
}

function product_drawer_color_swatch() {
  var colorSwatchWrapper = $(
      '#Product-Drawer-Content #color-swatches-search-wrapper'
    ),
    colorSwatchList = $('#Product-Drawer-Content #color-swatches-search'),
    fullTitle = colorSwatchWrapper.data('product-title').toUpperCase(),
    termHandle = fullTitle.toLowerCase().replace(/ /g, '-'),
    term = $.trim(fullTitle)
      .toLowerCase()
      .split(' ')
      .join('+')
      .replace(/\'/, ''),
    searchURL =
      '/search.json?q=' +
      term +
      '&type=product&view=colors&options[unavailable_products]=show&title=' +
      termHandle +
      '.json';

  $.getJSON(searchURL, function (data) {
    if (data.results_count == 0) {
      console.log('no swatches');
      $('.loader-3-dots').remove();
      $('.variations--color-swatch').hide();
    } else {
      $.each(data.results, function (index, item) {
        var item_title = item.title.toUpperCase();
        if (item_title == fullTitle) {
          var activeClass =
            item.color == colorSwatchWrapper.data('product-color')
              ? 'class="active"'
              : '';
          var itemUrl = (item.url || '').replace(/&variant=[0-9]*/, '');
          var productHandleMatch = (item.url || '')
            .split('?')[0]
            .match(/\/products\/(.*)/i);
          if (Array.isArray(productHandleMatch))
            var productHandle = productHandleMatch[1];

          var swatch;
          if (item.hex) {
            swatch =
              '<quick-view data-product-handle="' +
              item.handle +
              '" ' +
              activeClass +
              ' data-tooltip="' +
              item.color +
              '"><div class="color-square ' +
              item.available +
              '"><div class="color-square-inner" style="background-color:' +
              item.hex +
              '"><div class="loader-dots"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><rect width="24" height="24" fill="none"/><circle cx="18" cy="12" r="0" fill="#dcdcdc"><animate attributeName="r" begin=".67" calcMode="spline" dur="1.5s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle><circle cx="12" cy="12" r="0" fill="#dcdcdc"><animate attributeName="r" begin=".33" calcMode="spline" dur="1.5s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle><circle cx="6" cy="12" r="0" fill="#dcdcdc"><animate attributeName="r" begin="0" calcMode="spline" dur="1.5s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle></svg></div></div></div></quick-view>';
          } else if (item.image) {
            swatch =
              '<quick-view data-product-handle="' +
              item.handle +
              '" ' +
              activeClass +
              ' data-tooltip="' +
              item.color +
              '"><div class="color-square ' +
              item.available +
              '"><div class="color-square-inner" style="background-image: url(' +
              item.image +
              ')"><div class="loader-dots"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><rect width="24" height="24" fill="none"/><circle cx="18" cy="12" r="0" fill="#dcdcdc"><animate attributeName="r" begin=".67" calcMode="spline" dur="1.5s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle><circle cx="12" cy="12" r="0" fill="#dcdcdc"><animate attributeName="r" begin=".33" calcMode="spline" dur="1.5s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle><circle cx="6" cy="12" r="0" fill="#dcdcdc"><animate attributeName="r" begin="0" calcMode="spline" dur="1.5s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle></svg></div></div></div></quick-view>';
          } else {
            swatch =
              '<quick-view data-product-handle="' +
              item.handle +
              '" ' +
              activeClass +
              ' data-tooltip="' +
              item.color +
              '"><div class="color-square ' +
              item.available +
              '"><div class="color-square-inner"><div class="loader-dots"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><rect width="24" height="24" fill="none"/><circle cx="18" cy="12" r="0" fill="#dcdcdc"><animate attributeName="r" begin=".67" calcMode="spline" dur="1.5s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle><circle cx="12" cy="12" r="0" fill="#dcdcdc"><animate attributeName="r" begin=".33" calcMode="spline" dur="1.5s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle><circle cx="6" cy="12" r="0" fill="#dcdcdc"><animate attributeName="r" begin="0" calcMode="spline" dur="1.5s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle></svg></div></div></div></quick-view>';
          }
          colorSwatchList.append(swatch);
        }
      });

      if (colorSwatchList.children().length > 0) {
        $('.variations--color-swatch').fadeIn();
        $('.loader-3-dots').remove();
      }
      if (colorSwatchList.children().length == 1) {
        // colorSwatchList.hide();
      }
    }
  });
}

// Fancy JS Swatches Collection Page
if (
  $('body').hasClass('template-collection') ||
  $('body').hasClass('template-search')
) {
  document.addEventListener('algolia.instantSearch.onRender', function () {
    collection_color_swatch();
    filterShowmore();
    setTimeout(add_ads, 300);
    remove_ais_stats_text();
    hideEmptyFiltersWraper();
  });
}

function collection_color_swatch() {
  $('.product-card').each(function () {
    var productCard = $(this),
      colorSwatchWrapper = productCard.find('.color-swatches-search-wrapper'),
      colorSwatchList = productCard.find('.color-swatches-search'),
      productImage = productCard.find('.product-primary-image'),
      productImage2 = productCard.find('.product-secondary-image'),
      product_Price = productCard.find('.price ins span.amount'),
      product_Compair_Price = productCard.find('.price del span.amount');

    if (colorSwatchWrapper.length && colorSwatchList.length) {
      var fullTitle = colorSwatchWrapper.data('product-title').toUpperCase(),
        termHandle = fullTitle.toLowerCase().replace(/ /g, '-'),
        term = $.trim(fullTitle)
          .toLowerCase()
          .split(' ')
          .join('+')
          .replace(/\'/, ''),
        searchURL =
          '/search.json?q=' +
          term +
          '&type=product&view=colors&options[unavailable_products]=show&title=' +
          termHandle +
          '.json';

      $.getJSON(searchURL, function (data) {
        if (data.results_count == 0) {
          console.log('no swatches for ' + fullTitle);
        } else {
          $.each(data.results, function (index, item) {
            var item_title = item.title.toUpperCase();
            if (item_title == fullTitle) {
              var activeClass =
                item.color == colorSwatchWrapper.data('product-color')
                  ? 'class="swatch-item active"'
                  : 'class="swatch-item"';
              var itemUrl = (item.url || '').replace(/&variant=[0-9]*/, '');
              var item_Url = itemUrl.split('?')[0];
              if (document.querySelector('meta[name="collection-name"]')) {
                const collectionName = document
                  .querySelector('meta[name="collection-name"]')
                  .getAttribute('content');
                const collectionBread = localStorage.getItem(
                  'collection_breadcrumbs'
                );
                if (collectionBread != 'null') {
                  const encodedCollectionName =
                    '?breadcrumbs=' + collectionBread + ',' + collectionName;
                  item_Url = item_Url + encodedCollectionName;
                } else {
                  const encodedCollectionName =
                    '?breadcrumbs=' + collectionName;
                  item_Url = item_Url + encodedCollectionName;
                }
              }
              var productHandleMatch = (item.url || '')
                .split('?')[0]
                .match(/\/products\/(.*)/i);
              if (Array.isArray(productHandleMatch))
                var productHandle = productHandleMatch[1];
              if (item.color == colorSwatchWrapper.data('product-color')) {
                product_Price.html(item.price);
                product_Compair_Price.html(item.c_price);
                productImage.attr('src', item.p_image);
                productImage2.attr('src', item.p_image2);
                productImage.attr('srcset', item.p_image);
                productImage2.attr('srcset', item.p_image2);
                productCard.find('a').attr('href', item_Url);
                productCard.find('span.promo_text').html(item.promo_text);
              }

              var swatch;
              if (item.hex) {
                swatch =
                  '<div ' +
                  activeClass +
                  ' data-handle="' +
                  item.handle +
                  '" data-promo-text="' +
                  item.promo_text +
                  '" data-price="' +
                  item.price +
                  '" data-c-price="' +
                  item.c_price +
                  '" data-available="' +
                  item.available +
                  '" data-tags="' +
                  item.tags +
                  '" data-url="' +
                  item_Url +
                  '" data-image="' +
                  item.p_image +
                  '" data-image2="' +
                  item.p_image2 +
                  '"><div class="color-square ' +
                  item.available +
                  '"><div class="color-square-inner" style="background-color:' +
                  item.hex +
                  '"></div></div></div>';
              } else if (item.image) {
                swatch =
                  '<div ' +
                  activeClass +
                  ' data-handle="' +
                  item.handle +
                  '" data-promo-text="' +
                  item.promo_text +
                  '" data-price="' +
                  item.price +
                  '" data-c-price="' +
                  item.c_price +
                  '" data-available="' +
                  item.available +
                  '" data-tags="' +
                  item.tags +
                  '" data-url="' +
                  item_Url +
                  '" data-image="' +
                  item.p_image +
                  '" data-image2="' +
                  item.p_image2 +
                  '"><div class="color-square ' +
                  item.available +
                  '"><div class="color-square-inner" style="background-image: url(' +
                  item.image +
                  ')"></div></div></div>';
              } else {
                swatch =
                  '<div ' +
                  activeClass +
                  ' data-handle="' +
                  item.handle +
                  '" data-promo-text="' +
                  item.promo_text +
                  '" data-price="' +
                  item.price +
                  '" data-c-price="' +
                  item.c_price +
                  '" data-available="' +
                  item.available +
                  '" data-tags="' +
                  item.tags +
                  '" data-url="' +
                  item_Url +
                  '" data-image="' +
                  item.p_image +
                  '" data-image2="' +
                  item.p_image2 +
                  '"><div class="color-square ' +
                  item.available +
                  '"><div class="color-square-inner"></div></div></div>';
              }
              colorSwatchList.append(swatch);
            }
             $.ajax({
              url: `/products/${item.handle}.js`,
              dataType: 'json',
              success: function(product) {
                var productTags = product.tags.toString();
                $(`.swatch-item[data-handle=${item.handle}]`).attr('data-tags',productTags);
              },
              error: function(error) {
                console.error('Error fetching product:', error);
              }
            });
          });

          if (colorSwatchList.children().length > 0) {
            colorSwatchWrapper.fadeIn();
            swatchMultiSlider();
          }

          // Add hover event to swatches
          colorSwatchList.find('.swatch-item').hover(function () {
            // On mouse enter
            colorSwatchList.find('.swatch-item').removeClass('active');
            $(this).addClass('active');
            var newImage = $(this).data('image');
            var newImage2 = $(this).data('image2');
            var newUrl = $(this).data('url');
            var newHandle = $(this).data('handle');
            var newPrice = $(this).data('price');
            var newCPrice = $(this).data('c-price');
            var available = $(this).data('available');
            var data_promo_text = $(this).data('promo-text');
            if (newImage) {
              productImage.attr('src', newImage);
              productImage2.attr('src', newImage2);
              productImage.attr('srcset', newImage);
              productImage2.attr('srcset', newImage2);
            }
            if (newUrl) {
              productCard.find('a').attr('href', newUrl);
            }
            if (newHandle) {
              productCard
                .find('.product-card-quickview')
                .attr('data-product-handle', newHandle);
            }
            if (newPrice) {
              product_Price.html(newPrice);
            }
            if (newCPrice) {
              product_Compair_Price.html(newCPrice);
              product_Price.addClass('discounted');
              productCard.find('span.badge.onsale').remove();
              productCard
                .find('.product-featured-image-link')
                .before('<span class="badge onsale bottom right">Sale</span>');
            } else {
              product_Compair_Price.html('');
              product_Price.removeClass('discounted');
              productCard.find('span.badge.onsale').remove();
            }
            var tags = $(this).attr('data-tags');
            if (tags.includes('sign-up')) {
              productCard.find('span.badge.out-of-stock').remove();
              productCard
                .find('.product-featured-image-link')
                .before(
                  '<span class="badge out-of-stock bottom right">Sign Up</span>'
                );
            } else {
              productCard.find('span.badge.out-of-stock').remove();
            }
            if (data_promo_text) {
              productCard.find('span.promo_text').html(data_promo_text);
            } else {
              productCard.find('span.promo_text').html('');
            }
          });
        }
      });
    }
  });
}

/*size chart toggle code*/
$(document).on('click', '.chart-block h2', function (e) {
  $(this).toggleClass('active').next().slideToggle(500);
  return false;
});

/*Collection Page Design Change Algolia app code */
document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook(
    'beforeInstantSearchProductTemplate',
    function (_defaultTemplate, hit, html, components) {
      console.log("HIT: ", hit);
      let product_title = hit.title;
      let parts = product_title.split('-').map((part) => part.trim());
      let p_title = parts.length > 0 ? parts[0] : '';
      let p_color = parts.length > 1 ? parts[1] : '';
      return html`
        <product-card
          class="product-card text-center product-card--content-spacing-false product-card--border-false has-shadow--false"
          data-algolia-index="${hit.index}"
          data-algolia-position="${hit.productPosition}"
          data-algolia-queryid="${hit.queryID}"
          data-algolia-objectid="${hit.objectID}"
          data-handle="${hit.handle}"
          data-variant-id="${hit.objectID}"
          data-distinct="${hit._distinct}"
          data-product-id="${hit.id}"
        >
          <figure class="product-featured-image thb-hover">
            ${hit.tags.includes('sign-up') &&
            html`<span class="badge out-of-stock bottom right">Sign Up</span>`}
            ${hit.can_order &&
            hit.compare_at_price > hit.price &&
            html`<span class="badge onsale bottom right">Sale</span>`}
            <a
              href="${algoliaShopify.helpers.instantsearchLink(hit)}"
              title="${hit.title}"
              class="product-featured-image-link aspect-ratio aspect-ratio--adapt"
              style="--padding-bottom: 150.00000000000003%;"
            >
              <img
                class="product-secondary-image lazyload"
                width="640"
                height="960"
                data-src="${hit.image}&width=320"
              />
              <img
                class="product-primary-image lazyload"
                width="640"
                height="960"
                data-src="${hit.product_image}&width=320"
              />
              <quick-view
                class="product-card-quickview"
                data-product-handle="${hit.handle}"
                tabindex="-1"
              >
                <div class="loading-overlay">
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    role="presentation"
                    class="spinner"
                    viewBox="0 0 66 66"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      class="spinner-path"
                      fill="none"
                      stroke-width="6"
                      cx="33"
                      cy="33"
                      r="30"
                      stroke="var(--color-body)"
                    ></circle>
                  </svg>
                </div>
                <span>Quickshop</span>
              </quick-view>
            </a>
          </figure>
          <div
            class="color-swatches-search-wrapper"
            style="display: none;"
            data-product-title="${p_title}"
            data-product-color="${p_color}"
          >
            <button
              class="arrow left-arrow"
              style="display: none;"
              onclick="scrollLeft(this)"
            >
              <svg
                width="7.2"
                height="14"
                viewBox="0 0 19 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.7 3.40002L3.09996 16L15.7 28.6"
                  stroke="currentcolor"
                  stroke-width="4"
                  stroke-linecap="square"
                ></path>
              </svg>
            </button>
            <div class="color-swatches-search"></div>
            <button
              class="arrow right-arrow"
              style="display: none;"
              onclick="scrollRight(this)"
            >
              <svg
                width="7.2"
                height="14"
                viewBox="0 0 20 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.76282 28.6L16.3628 16L3.76282 3.39998"
                  stroke="currentcolor"
                  stroke-width="4"
                  stroke-linecap="square"
                ></path>
              </svg>
            </button>
          </div>
          <div class="product-card-info">
            <a
              href="${algoliaShopify.helpers.instantsearchLink(hit)}"
              title="${hit.title}"
              class="product-card-title"
              >${p_title}</a
            >
            <span class="price">
              <ins
                ><span
                  class="amount ${hit.can_order &&
                  hit.compare_at_price > hit.price &&
                  html`discounted`}"
                  >${algoliaShopify.helpers.displayPrice(
                    hit,
                    hit._distinct
                  )}</span
                ></ins
              >
              ${hit._distinct &&
              html`
                <del
                  ><span class="amount"
                    >${algoliaShopify.helpers.displayStrikedPrice(
                      hit.price,
                      hit.compare_at_price
                    )}</span
                  ></del
                >
              `}
            </span>
            <span class="promo_text"></span>
          </div>
        </product-card>
      `;
    }
  );
});

document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook(
    'beforeInstantSearchMainTemplate',
    function (_defaultTemplate, data, html) {
      return html`
        <div class="ais-page">
          <h1 class="ais-h2">${algoliaShopify.translations.searchTitle}</h1>
          <div class="ais-input">
            <div class="ais-search-box-container"></div>
            <div class="ais-input-button">
              <div class="ais-clear-input-icon"></div>
            </div>
          </div>
          <div class="ais-facets-button">Show filters</div>
          <div class="ais-facets">
            <div class="ais-clear-refinements-container"></div>
            <div class="ais-current-refined-values-container"></div>
            ${data.facets.map(
              (facet) =>
                html`
                  <div
                    class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                  >
                    <label
                      for="${facet.escapedName}"
                      class="ais-range-slider--header ais-facet--header ais-header"
                      >${facet.title}</label
                    >
                    <input
                      class="ais-dropdown-checkbox"
                      type="checkbox"
                      id="${facet.escapedName}"
                      name="dropdown"
                    />
                    <div
                      class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                    ></div>
                  </div>
                `
            )}
          </div>
          <div class="ais-block">
            <div class="ais-search-header">
              <div class="ais-stats-container"></div>
              <div class="ais-change-display">
                <span
                  class="ais-change-display-block ais-change-display-selected"
                  ><i class="fa fa-th-large"></i
                ></span>
                <span class="ais-change-display-list"
                  ><i class="fa fa-th-list"></i
                ></span>
              </div>
              <div class="ais-sort">
                ${data.multipleSortOrders
                  ? html`
                      Sort By:
                      <span class="ais-sort-orders-container"></span>
                    `
                  : html` Sort By: ${algoliaShopify.translations.relevance} `}
              </div>
            </div>
            <div class="ais-hits-container ais-results-as-block"></div>
          </div>
          <div class="ais-pagination-container"></div>
        </div>
      `;
    }
  );
});

document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook(
    'beforeInstantSearchFacetItemTemplate',
    function (_defaultTemplate, item, html) {
      return html`
        <label class="${item.cssClasses.label}">
          ${item.type === 'disjunctive' &&
          (item.isRefined
            ? html`
                <input
                  type="checkbox"
                  class="${item.cssClasses.checkbox}"
                  checked
                />
                <span class="custom-checkbox checked"></span>
              `
            : html`
                <input type="checkbox" class="${item.cssClasses.checkbox}" />
                <span class="custom-checkbox"></span>
              `)}
          ${item.attribute == 'named_tags.Color Family' &&
          html`<div
            class="color-square-inner swatch-color-${convertToHandle(
              item.label
            )}"
          ></div>`}
          ${item.label}
          <span class="ais-RefinementList-count ais-facet--count">
            (${algoliaShopify.helpers.formatNumber(item.count)})
          </span>
        </label>
      `;
    }
  );
});

document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook(
    'beforeInstantSearchFacetLimitNumber',
    function (limit) {
      return 1000;
    }
  );
});

function convertToHandle(label) {
  let handle = label.toLowerCase();
  handle = handle.replace(/\s+/g, '-');
  handle = handle.replace(/[^\w\-]+/g, '');
  handle = handle.replace(/\-\-+/g, '-');
  handle = handle.replace(/^-+/, '').replace(/-+$/, '');

  return handle;
}

/*Remove Extra ais_stats_text filter header*/
function remove_ais_stats_text() {
  const statsText = document.querySelector('.ais-Stats-text');
  if (statsText) {
    function cleanTextNodes(element) {
      element.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          // Remove 'found' and 'in' with everything following it
          node.nodeValue = node.nodeValue
            .replace(' found', '')
            .replace(/in .*/, '');
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          cleanTextNodes(node);
        }
      });
    }
    cleanTextNodes(statsText);
  }
}

/*Filter add accordian icon*/
$(document).on('click', 'label.ais-facet--header', function () {
  $(this).toggleClass('remove');
});

/*Add Ads in collection product list*/
function add_ads() {
  const olElement = document.querySelector('.ais-Hits-list');
  const liElements = olElement.getElementsByTagName('li');
  const itemsToRemove = olElement.querySelectorAll('.ais-Hits-item.ads-banner');
  
  let listOfAds = algolia_ads.reduce((acc, item) => {
    if (item.is_global === 'true') {
      acc[item.position] = item;
    }
    return acc;
  }, {});
  const pageAds = algolia_ads.filter(
    (item) => item.display_page_url === window.location.pathname
  );
  pageAds.forEach((pageAd) => {
    listOfAds[pageAd.position] = pageAd;
  });

  if (itemsToRemove) {
    itemsToRemove.forEach(function (item) {
      item.remove();
    });
  }
  console.log(liElements.length);
  for (let i = 0; i < liElements.length; i++) {
    const displayAd = listOfAds[i];
    if (displayAd) {
      const newLiElement = $(`<li class="ais-Hits-item ads-banner">
                                    <div class="gallery--item" style="--overlay-color-rgb: 0,0,0; --overlay-opacity: 0.0">
                                      <a href="${displayAd.url}" >
                                       <figure class="aspect-ratio aspect-ratio--adapt" style="padding-bottom: 150.00000000000003%;">
                                          <img width="600" height="900" class="lazyload" data-src="${displayAd.image}" />
                                       </figure>
                                      </a>
                                    </div>
                                  </li>`);
      $(liElements[i]).before(newLiElement);
    }
  }
}

/*Add banners in collection page*/
if (
  $('body').hasClass('template-collection') ||
  $('body').hasClass('template-search')
) {
  let thisBanner;
  let pageBanner = algolia_banners.find(
    (item) => item.display_page_url === window.location.pathname
  );
  let listOfBanners = {};
  if (!pageBanner) {
    pageBanner = algolia_banners.find((item) => item.is_global === 'true');
  }
  checkElementModule.checkElement('#page-banner').then(function (element) {
    const bannerElement = document.getElementById('page-banner');
    const templateHeader = document.getElementsByClassName('template-header');
    if (pageBanner && bannerElement) {
      const htmlBlock = $(`
            <a href="${pageBanner.url}">
              <img style="width: 100%;" class="lazyload" aria-label="${pageBanner.alt}" data-src="${pageBanner.image}" />
            </a>
          `);
      $(bannerElement).html(htmlBlock);
      $(templateHeader).empty().css('padding', '0px');
    }
  });
}

checkElementModule
  .checkElement('.seo-content .content-description')
  .then(function (element) {
    const content = document.querySelector('.seo-content .content-description');
    content.dataset.defaultMaxHeight = content.clientHeight;
  });
function toggleExpandedText() {
  const content = document.querySelector('.seo-content .content-description');
  const button = document.querySelector('.seo-content .more-btn span');
  if (content.classList.contains('expanded')) {
    content.style.maxHeight = content.dataset.defaultMaxHeight + 'px';
    content.classList.remove('expanded');
    button.textContent = 'show more';
  } else {
    content.style.maxHeight = content.scrollHeight + 20 + 'px';
    content.classList.add('expanded');
    button.textContent = 'show less';
  }
}

function filterShowmore() {
  const ulElements = document.querySelectorAll('ul.ais-RefinementList-list');
  const itemsToRemove = document.querySelectorAll('button.show-more-btn');
  if (itemsToRemove) {
    itemsToRemove.forEach(function (item) {
      item.remove();
    });
  }
  ulElements.forEach((ul) => {
    ul.classList.remove('scroll-bar');
    ul.classList.remove('active');
    const liElements = ul.querySelectorAll('.ais-facet--item');
    if (liElements.length > 11) {
      ul.classList.add('scroll-bar');
      const showMoreButton = document.createElement('button');
      showMoreButton.className = 'show-more-btn';
      showMoreButton.innerHTML = `<data class="icon"></data> <span>Show More</span>`;
      showMoreButton.addEventListener('click', () => {
        ul.classList.toggle('active');
        showMoreButton.classList.toggle('active');
        if (showMoreButton.classList.contains('active')) {
          showMoreButton.innerHTML = `<data class="icon minus"></data> <span>Show Less</span>`;
        } else {
          showMoreButton.innerHTML = `<data class="icon"></data> <span>Show More</span>`;
        }
      });
      ul.after(showMoreButton);
    }
  });
}

/*Sort By Label Change Code*/
checkElementModule.checkElement('.ais-SortBy-select').then(function (element) {
  const relevanceOption = document.querySelector(
    '.ais-SortBy-select option[value="shopify_products"]'
  );
  if (relevanceOption) {
    relevanceOption.textContent = 'Best Match';
  }
});

/*Color swatch Slider code*/
window.addEventListener('resize', swatchMultiSlider);
function swatchMultiSlider() {
  const containers = document.querySelectorAll(
    '.color-swatches-search-wrapper'
  );

  containers.forEach((container) => {
    const scrollableContent = container.querySelector('.color-swatches-search');
    container.classList.remove('scroll-arrow');
    if (scrollableContent.scrollWidth > scrollableContent.clientWidth) {
      container.classList.add('scroll-arrow');
    }

    const leftArrow = container.querySelector('.left-arrow');
    const rightArrow = container.querySelector('.right-arrow');

    function updateArrows() {
      const maxScrollLeft =
        scrollableContent.scrollWidth - scrollableContent.clientWidth;

      if (scrollableContent.scrollLeft <= 0) {
        leftArrow.classList.add('disabled');
      } else {
        leftArrow.classList.remove('disabled');
      }

      if (scrollableContent.scrollLeft >= maxScrollLeft) {
        rightArrow.classList.add('disabled');
      } else {
        rightArrow.classList.remove('disabled');
      }
    }

    leftArrow.addEventListener('click', function () {
      scrollLeft(this);
    });

    rightArrow.addEventListener('click', function () {
      scrollRight(this);
    });

    scrollableContent.addEventListener('scroll', updateArrows);

    // Initial check to update the state of the arrows
    updateArrows();
  });
}
function scrollLeft(button) {
  const container = button.closest('.color-swatches-search-wrapper');
  const scrollableContent = container.querySelector('.color-swatches-search');
  scrollableContent.scrollBy({
    left: -33,
    behavior: 'smooth',
  });
}
function scrollRight(button) {
  const container = button.closest('.color-swatches-search-wrapper');
  const scrollableContent = container.querySelector('.color-swatches-search');
  scrollableContent.scrollBy({
    left: 33,
    behavior: 'smooth',
  });
}

/*toggle mobile filter js*/
$(document).on('click', '.ais-facets-button', function (event) {
  $(this).toggleClass('active');
  if ($(this).siblings('.ais-facets__shown').find('.close').length === 0) {
    $(this)
      .siblings('.ais-facets__shown')
      .prepend(
        '<span class="close"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 56 56" preserveAspectRatio="xMinYMid"><path fill="#fff" d="M56 5.638 33.638 28 56 50.362 50.362 56 28 33.638 5.638 56 0 50.362 22.362 28 0 5.638 5.638 0 28 22.362 50.362 0z"/></svg></span>'
      );
  }
});
$(document).on('click', '.ais-facets__shown .close', function (event) {
  var button = $(this)
    .closest('.ais-facets__shown')
    .siblings('.ais-facets-button');
  button.trigger('click');
});

/*afterpay popup code*/
document
  .querySelector('a[data-popup-id]')
  ?.addEventListener('click', function (event) {
    event.preventDefault();
    var popupId = this.getAttribute('data-popup-id');
    var popupElement = document.querySelector(popupId);
    if (popupElement) {
      popupElement.setAttribute('open', true);
      document.body.classList.add('overflow-hidden-afterpay');
    }
  });
// Close popup when clicking outside the inner content
document
  .querySelector('#davids-afterpay-popup')
  ?.addEventListener('click', function (event) {
    var innerPopup = document.querySelector('.davids-afterpay-popup__inner');
    if (!innerPopup.contains(event.target)) {
      var popupElement = document.querySelector('#davids-afterpay-popup');
      if (popupElement) {
        popupElement.removeAttribute('open');
        document.body.classList.remove('overflow-hidden-afterpay');
      }
    }
  });
document
  .querySelector('.close-afterpay-popup')
  ?.addEventListener('click', function (event) {
    var popupElement = document.querySelector('#davids-afterpay-popup');
    if (popupElement) {
      popupElement.removeAttribute('open');
      document.body.classList.remove('overflow-hidden-afterpay');
    }
  });

/**
 * Customize Recommended section
 */
document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook(
    'beforeRecommendHitTemplate',
    function (_defaultTemplate, html, item) {
      localStorage.setItem('userSettings', JSON.stringify(item));
      let parts = item.title.split('-').map((part) => part.trim());
      let p_title = parts.length > 0 ? parts[0] : '';
      let p_color = parts.length > 0 ? parts[1] : '';
      return html`
        <product-card
          class="product-card text-center product-card--content-spacing-false product-card--border-false has-shadow--false get-orignal-product-data"
          data-handle="${item.handle}"
          data-product-title="${item.title}"
          data-product-color="${p_color}"
          data-variant-id="${item.objectID}"
          data-product-id="${item.id}"
        >
          <figure class="product-featured-image thb-hover">
            ${item.compare_at_price > item.price &&
            html`<span class="badge onsale bottom right">Sale</span>`}
            <a
              href="/products/${item.handle}"
              title="${item.title}"
              class="product-featured-image-link aspect-ratio aspect-ratio--adapt"
              style="--padding-bottom: 150.00000000000003%;"
            >
              <img
                class="product-secondary-image lazyload"
                width="640"
                height="960"
                data-src="${item.image}}&width=320"
              />
              <img
                class="product-primary-image"
                width="640"
                height="960"
                data-src="${item.product_image}&width=320"
                loading="lazy"
              />
              <quick-view
                class="product-card-quickview"
                data-product-handle="${item.handle}"
                tabindex="-1"
              >
                <div class="loading-overlay">
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    role="presentation"
                    class="spinner"
                    viewBox="0 0 66 66"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      class="spinner-path"
                      fill="none"
                      stroke-width="6"
                      cx="33"
                      cy="33"
                      r="30"
                      stroke="var(--color-body)"
                    ></circle>
                  </svg>
                </div>
                <span>Quickshop</span>
              </quick-view>
            </a>
          </figure>
          <div class="product-card-info">
            <a
              href="/products/${item.handle}"
              title="${item.title}"
              class="product-card-title"
              >${p_title}</a
            >
            <span class="price">
              <ins
                ><span
                  class="amount ${item.compare_at_price > item.price &&
                  html`discounted`}"
                  >$${item.price}</span
                ></ins
              >
              ${item.compare_at_price > item.price &&
              html`
                <del
                  ><span class="amount"
                    >$${item.compare_at_price}</span
                  ></del
                >
              `}
            </span>
            <span class="promo_text"></span>
          </div>
        </product-card>
      `;
    }
  );
});

const intervalId = setInterval(() => {
  const sliderEle = document.querySelector('.uic-HorizontalSlider-list');
  if (sliderEle) {
    new Flickity('.uic-HorizontalSlider-list', {
      groupCells: true,
    });
    clearInterval(intervalId);
  }
}, 100);

/* Cookies */
!(function (e) {
  if ('function' == typeof define && define.amd) define(e);
  else if ('object' == typeof exports) module.exports = e();
  else {
    var n = window.Cookies,
      o = (window.Cookies = e(window.jQuery));
    o.noConflict = function () {
      return (window.Cookies = n), o;
    };
  }
})(function () {
  function e() {
    for (var e = 0, n = {}; e < arguments.length; e++) {
      var o = arguments[e];
      for (var t in o) n[t] = o[t];
    }
    return n;
  }
  function n(o) {
    function t(n, r, i) {
      var c;
      if (arguments.length > 1) {
        if (
          ((i = e({ path: '/' }, t.defaults, i)), 'number' == typeof i.expires)
        ) {
          var s = new Date();
          s.setMilliseconds(s.getMilliseconds() + 864e5 * i.expires),
            (i.expires = s);
        }
        try {
          (c = JSON.stringify(r)), /^[\{\[]/.test(c) && (r = c);
        } catch (a) {}
        return (
          (r = encodeURIComponent(String(r))),
          (r = r.replace(
            /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
            decodeURIComponent
          )),
          (n = encodeURIComponent(String(n))),
          (n = n.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)),
          (n = n.replace(/[\(\)]/g, escape)),
          (document.cookie = [
            n,
            '=',
            r,
            i.expires && '; expires=' + i.expires.toUTCString(),
            i.path && '; path=' + i.path,
            i.domain && '; domain=' + i.domain,
            i.secure && '; secure',
          ].join(''))
        );
      }
      n || (c = {});
      for (
        var p = document.cookie ? document.cookie.split('; ') : [],
          u = /(%[0-9A-Z]{2})+/g,
          d = 0;
        d < p.length;
        d++
      ) {
        var f = p[d].split('='),
          l = f[0].replace(u, decodeURIComponent),
          m = f.slice(1).join('=');
        if (
          ('"' === m.charAt(0) && (m = m.slice(1, -1)),
          (m = (o && o(m, l)) || m.replace(u, decodeURIComponent)),
          this.json)
        )
          try {
            m = JSON.parse(m);
          } catch (a) {}
        if (n === l) {
          c = m;
          break;
        }
        n || (c[l] = m);
      }
      return c;
    }
    return (
      (t.get = t.set = t),
      (t.getJSON = function () {
        return t.apply({ json: !0 }, [].slice.call(arguments));
      }),
      (t.defaults = {}),
      (t.remove = function (n, o) {
        t(n, '', e(o, { expires: -1 }));
      }),
      (t.withConverter = n),
      t
    );
  }
  return n();
});

function hideEmptyFiltersWraper() {
  $('.ais-facet-dropdown-wrapper').each(function () {
    var refinementList = $(this).find('.ais-RefinementList');
    if (refinementList.is(':empty')) {
      $(this).hide();
    } else {
      $(this).show();
    }
  });
}

document.addEventListener('cart:item-added', function (event) {  
  let elements = document.querySelectorAll('.thb-item-count');
  elements.forEach(function(element) {
    let countValue = element.innerHTML;
    element.setAttribute('data-count', countValue);
  });
});
document.addEventListener('line-item:change:end', function (event) {  
  let elements = document.querySelectorAll('.thb-item-count');
  elements.forEach(function(element) {
    let countValue = element.innerHTML;
    element.setAttribute('data-count', countValue);
  });
});


/*product set orignal data algolia widget*/
checkElementModule.checkElement('.get-orignal-product-data').then(function (element) {
    get_orignal_product_data();
});
function get_orignal_product_data() {
  $('.product-card.get-orignal-product-data').each(function () {
    var productCard = $(this),
      fullTitle = $(this).data('product-title').toUpperCase(),
      product_id = $(this).data('product-id'),
      productImage = productCard.find('.product-primary-image'),
      productImage2 = productCard.find('.product-secondary-image'),
      product_Price = productCard.find('.price ins span.amount'),
      product_Compair_Price = productCard.find('.price del span.amount');

    if (fullTitle.length) {
    var termHandle = fullTitle.toLowerCase().replace(/ /g, '-');
    var term = $.trim(fullTitle).toLowerCase().split(' ').join('+').replace(/\'/, '');
    var searchURL = '/search.json?q=' + term +'&type=product&view=product-info&options[unavailable_products]=show&product_id='+product_id;

      $.getJSON(searchURL, function (data) {
        if (data.results_count == 0) {
          console.log('No Product Found ' + product_handle);
        } else {
          $.each(data.results, function (index, item) {
            var item_id = item.p_id;
            if (item_id == product_id) {
                product_Price.html(item.price);
                product_Compair_Price.html(item.c_price);
                productImage.attr('src', item.p_image);
                productImage2.attr('src', item.p_image2);
                productImage.attr('srcset', item.p_image);
                productImage2.attr('srcset', item.p_image2);
                productCard.find('span.promo_text').html(item.promo_text);
                if (item.tags.includes('sign-up')) {
                  productCard.find('span.badge.onsale').remove();
                  productCard.find('.product-featured-image-link').before('<span class="badge out-of-stock bottom right">Sign Up</span>');
                }
            }
          });
        }
      });
    }
  });
}

$(document).on("click", "#notify_button", function(e) {
    e.preventDefault();
    var email = $('#notify_email').val();
    var productId = $(this).attr("data-product-id");
    var variantId = document.getElementById("productId").value;
    if(email && productId && variantId){
      BIS.create(email, variantId, productId).then(notificationCallback);
    }
});
var notificationCallback = function(data) {
  var msg = '';
  if (data.status == 'OK') {
    $('#notify_email').val(" ");
    $("#response").text(`${data.message}`);
     setTimeout(() => {
          $("#response").text(` `);
        }, 2000);
  } else { // it was an error
    if(data.errors.base[0] != undefined){
      $("#response").text(`${data.errors.base[0]}`);
        setTimeout(() => {
          $("#response").text(` `);
        }, 2000);
    }else{ 
     $("#response").text(`${data.errors.email[0]}`);
       setTimeout(() => {
          $("#response").text(` `);
        }, 2000);
    }
  }
}